var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 36,
    height: 36,
    rx: 7.8646,
    fill: "#00389C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.7598 7.57491C24.1206 7.36405 23.438 7.25 22.7289 7.25C19.1274 7.25 16.2078 10.1924 16.2078 13.8221C16.2078 14.7897 16.4153 15.7084 16.7878 16.5357L6.75 26.652L9.82409 29.75L19.8004 19.6958C20.6809 20.1426 21.6758 20.3941 22.7289 20.3941C26.3304 20.3941 29.25 17.4517 29.25 13.8221C29.25 13.0103 29.104 12.2328 28.8369 11.515L24.1668 16.2217L21.0173 15.3712L20.1734 12.1971L24.7598 7.57491Z",
    fill: "#F6F7FA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPart);
export default __webpack_public_path__ + "static/media/part.685579db8673a7c88144af3556059633.svg";
export { ForwardRef as ReactComponent };